import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ROUTES } from "./routes.config";
import PrivateRoute from "./PrivateRoutes";
import LoadingOverlay from "../shared/ui/LoadingOverlay";
import Login from "../features/login/pages/login";
import { DeepSearch } from "../features/deep-search/pages";
import SuperAdmin from "../features/superAdmin/pages";
import { Tenants } from "../features/tenants/pages";
import { Tenant } from "../features/tenants/pages/tenant";

 

const NotFound = React.lazy(() =>
  Promise.resolve({
    default: () => (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
          <p className="text-gray-600 mb-8">Page not found</p>
          <Navigate to={ROUTES.HOME} replace />
        </div>
      </div>
    ),
  })
);

const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingOverlay />}>
      <Routes>
        {/* Public Routes */}
        <Route path={ROUTES.LOGIN} element={<Login />} />

        {/* Protected Routes */}
        <Route
          path={ROUTES.HOME}
          element={
            <PrivateRoute>
              <Tenants />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.DEEP_SEARCH}
          element={
            <PrivateRoute>
              <DeepSearch />
            </PrivateRoute>
          }
        />

        <Route
          path={ROUTES.REPORT_DETAIL}
          element={
            <PrivateRoute>
              <Tenant />
            </PrivateRoute>
          }
        />

        <Route
          path={ROUTES.SUPER_ADMIN}
          element={
            <PrivateRoute requiredPermissions={["SUPER_ADMIN"]}>
              <SuperAdmin />
            </PrivateRoute>
          }
        />

        {/* 404 Route */}
        <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
